import { z } from 'zod';
import { baseObjectSchema } from '../baseSchemas';
export const getVisitsSchema = baseObjectSchema.extend({
  salesPersonID: z.string(),
  salesPerson: z.object({
    id: z.string(),
    code: z.string(),
    name: z.string(),
  }),
  traderSiteID: z.string(),
  traderSite: z.object({
    id: z.string(),
    code: z.string(),
    name: z.string(),
  }),
  visitMissedReasonID: z.string().optional(),
  visitMissedReason: z
    .object({
      id: z.string(),
      code: z.string(),
      name: z.string(),
    })
    .optional(),
  visitDate: z.string(),
  planned: z.boolean(),
  executed: z.boolean(),
  missed: z.boolean(),
  visitRemarks: z.string().optional(),
});
export type GetVisitsResponse = z.infer<typeof getVisitsSchema>;
